[
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "3c4f9e2a-8b1e-4c7f-91d4-2a6d7b5f8e3a",
    "name": "South West"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "5d6e7f8a-9b2c-4d8f-92e5-3b7e8c9f0a4b",
    "name": "Mid Atlantic"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
    "name": "South East"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d",
    "name": "Mountain West"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
    "name": "North West"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f",
    "name": "Mid West"
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "uuid": "89e1325d-c6fa-4e21-add9-35754c1545b7",
    "name": "North East"
  }
]
